import PropTypes from 'prop-types';
import HspDropdown from '../../Dropdowns/HspDropdown/HspDropdown';
import {getDisplayValue} from './chooseTubingUtils';

/**
 * Stateless dropdown for shrink ratio selection.
 */
function ShrinkRatioDropdown({
  choices,
  design,
  isCompatible,
  heatshrinkCompatibility,
  lastSelected,
  compatibilityLookup,
  onSelect: _onSelect,
  util
}) {
  return (
    <HspDropdown
      label={{labelContent: 'Shrink Ratio (R)', labelKey: 'shrinkRatio'}}
      topLevelClassNames={
        !isCompatible &&
        heatshrinkCompatibility?.safestActions?.includes('shrinkRatio') &&
        lastSelected !== 'shrinkRatio'
          ? 'has-error'
          : ''
      }
      dropdownMenuItems={choices}
      dropdownToggleItems={{
        isDropdownActive: false,
        dropdownText: getDisplayValue('shrinkRatio', design.shrinkRatio, util),
        dropdownClasses:
          !compatibilityLookup['shrinkRatio'] && lastSelected !== 'shrinkRatio'
            ? 'not-compatible'
            : ''
      }}
    />
  );
}

ShrinkRatioDropdown.propTypes = {
  choices: PropTypes.array.isRequired,
  design: PropTypes.object.isRequired,
  isCompatible: PropTypes.bool.isRequired,
  heatshrinkCompatibility: PropTypes.object,
  lastSelected: PropTypes.string.isRequired,
  compatibilityLookup: PropTypes.object.isRequired,
  onSelect: PropTypes.func,
  util: PropTypes.object.isRequired
};

export default ShrinkRatioDropdown;
